"use strict";

var layerData = {
  streets: {
    dataset: "osm_street_network_database_clip",
    style: `#osm_street_network_database_clip['mapnik::geometry_type'=2]{
      [class='motorway'][zoom>=10],
      [class='trunk'][zoom>=13],
      [class='primary'][zoom>=14],
      [class='secondary'][zoom>=15],
      [class='residential'][zoom>=16],
      [class='tertiary'][zoom>=15],
      [class='minor'][zoom>=16],
      [class='service'][zoom>=17],
      [class='path'][zoom>=17],
      [class='track'][zoom>=18]{
        text-avoid-edges: true;
        text-name: [name];
        text-placement: line;
        text-face-name: 'Open Sans Bold';
        text-fill: #6a7584;
        text-halo-fill: fadeout(white, 30%);
        text-halo-radius: 0.75;
        text-min-distance: 200;
        text-size: 12;

        [class='motorway'],
        [class='trunk'],
        [class='primary']{
          text-face-name: 'Open Sans Bold';
          text-halo-fill: #fefde1;
          text-fill: #6a7584;
          text-size: 12;
          [class='motorway'], [class='trunk'] { text-halo-fill: #fff0c4; }
        }

        [class='secondary']{
          text-fill: #6a7584;
          text-size: 11;
        }
        [class='tertiary']{
          text-fill: #6a7584;
          text-size: 10;
        }
        [class='residential']{
          text-fill: #6a7584;
          text-size: 9;
        }
        [class='path'],
        [class='track']{
          text-fill: #6a7584;
        }
      }
    }`
  },

  boundaries: {
    dataset: "zillow_nbhds_clipped_v2",
    style: `#layer['mapnik::geometry_type'=3] {
      polygon-fill: #826DBA;
      polygon-opacity:0;
      ::outline {
        line-color: #4d4c44;
        line-width: 2;
        line-opacity: 0.5;
      }
    #layer::labels [zoom>=13] {
      text-name:  '[name]';
      text-face-name: 'Open Sans Bold';
      text-size: 10;
      text-fill: #383832;
      }
    }`
  },

    "2020": {
    dataset: "seattle_zoning_2020_v4",
    style: `#layer [zoom > 9]{
      [carto_cat = 'Single Family']{
        polygon-fill: #f7f777;
      }
      [carto_cat = 'Multi-Family']{
        polygon-fill: #fb9725;
      }
      [carto_cat = 'Parks and Other Public Lands']{
        polygon-fill: #cbe5a8;
      }
      [carto_cat = 'All Other Zones']{
        polygon-fill: #ccc385;
      }
    }`
  },

  "2017": {
    dataset: "seattle_zoning_2017_v8_nbhd_int",
    style: `#layer [zoom > 9]{
      [carto_cat = 'Single Family']{
        polygon-fill: #f7f777;
      }
      [carto_cat = 'Multi-Family']{
        polygon-fill: #fb9725;
      }
      [carto_cat = 'Parks and Other Public Lands']{
        polygon-fill: #cbe5a8;
      }
      [carto_cat = 'All Other Zones']{
        polygon-fill: #ccc385;
      }
    }`
  },

  "1960": {
    dataset: "seattle_zoning_1960_v14_nbhd_int",
    style: `#layer [zoom > 9]
      {
      [carto_cat = 'Single Family']{
        polygon-fill: #f7f777;
      }
      [carto_cat = 'Multi-Family']{
        polygon-fill: #fb9725;
      }
      [carto_cat = 'Parks and Other Public Lands']{
        polygon-fill: #cbe5a8;
      }
      [carto_cat = 'All Other Zones']{
        polygon-fill: #ccc385;
      }
    }`
  },

  "1923": {
    dataset: "seattle_zoning_1923_v8_nbhd_int",
    style: `#layer [zoom > 9]
      {
      [carto_cat = 'Single Family']{
        polygon-fill: #f7f777;
      }
      [carto_cat = 'Multi-Family']{
        polygon-fill: #fb9725;
      }
      [carto_cat = 'Parks and Other Public Lands']{
        polygon-fill: #cbe5a8;
      }
      [carto_cat = 'Unzoned Land']{
        polygon-fill: #E8E0D8;
      }
      [carto_cat = 'All Other Zones']{
        polygon-fill: #ccc385;
      }
    }`
  },

  "1917": {
    dataset: "seattle_zoning_1917_nbhd_int_v1",
      style: `#layer [zoom > 9]
      {
      [carto_cat = 'Single Family']{
        polygon-fill: #f7f777;
      }
      [carto_cat = 'Multi-Family']{
        polygon-fill: #fb9725;
      }
      [carto_cat = 'Parks and Other Public Lands']{
        polygon-fill: #cbe5a8;
      }
      [carto_cat = 'Unzoned Land']{
        polygon-fill: #E8E0D8;
      }
      [carto_cat = 'All Other Zones']{
        polygon-fill: #ccc385;
      }
    }`
  }
};

const clientSettings = {
  apiKey: "AfC5i4HXV58bs1LdkGiTTA",
  username: "sightline"
};
const leafletLayerUrl =
  "https://{s}.basemaps.cartocdn.com/rastertiles/voyager_nolabels/{z}/{x}/{y}.png";
const mapMaxZoom = 18;
const $document = $(document);
const $body = $("body");
const $mapContainer = $(".map-container");
const $rightMap = $(".map--right");
const $leftMap = $(".map--left");
const $leftMapContainer = $(".map-container-left");
const $rightButtonGroup = $('input[name="right"]');
const $leftButtonGroup = $('input[name="left"]');
const $scroller = $(".scroller");
const $controls = $(".controls");
const $dateLabel = $(".date--left");
const $areaLabel = $(".area-name");
const $buttonShowAll = $(".button--show-all");
const rightLayerIndex = 2;
const leftLayerIndex = 1;

const leftClient = new carto.Client(clientSettings);
const rightClient = new carto.Client(clientSettings);

let currentRightLayer,
  currentLeftLayer,
  layers,
  datasets,
  widgets,
  leftMap,
  rightMap,
  neighborhoodFilter;
let scrolling = false;

// Polyfills for internet explorer
if (Number.parseFloat === undefined) {
  Number.parseFloat = parseFloat;
}

// https://tc39.github.io/ecma262/#sec-array.prototype.find
if (!Array.prototype.find) {
  Object.defineProperty(Array.prototype, "find", {
    value: function(predicate) {
      // 1. Let O be ? ToObject(this value).
      if (this == null) {
        throw new TypeError('"this" is null or not defined');
      }

      var o = Object(this);

      // 2. Let len be ? ToLength(? Get(O, "length")).
      var len = o.length >>> 0;

      // 3. If IsCallable(predicate) is false, throw a TypeError exception.
      if (typeof predicate !== "function") {
        throw new TypeError("predicate must be a function");
      }

      // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
      var thisArg = arguments[1];

      // 5. Let k be 0.
      var k = 0;

      // 6. Repeat, while k < len
      while (k < len) {
        // a. Let Pk be ! ToString(k).
        // b. Let kValue be ? Get(O, Pk).
        // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
        // d. If testResult is true, return kValue.
        var kValue = o[k];
        if (predicate.call(thisArg, kValue, k, o)) {
          return kValue;
        }
        // e. Increase k by 1.
        k++;
      }

      // 7. Return undefined.
      return undefined;
    },
    configurable: true,
    writable: true
  });
}

const swapLayer = (currentLayer, client) => {
  return event => {
    client.removeLayer(layers["streets"]);
    client.removeLayer(layers["boundaries"]);
    client.removeLayer(currentLayer);
    currentLayer = layers[event.target.value];
    $dateLabel.text(event.target.value);
    client.addLayer(currentLayer).catch(cartoError => {
      console.error("error adding layer:", cartoError.message);
    });
    client.addLayer(layers["boundaries"]);
    client.addLayer(layers["streets"]);
  };
};

const respondToSlider = pageX => {
  if (scrolling) {
    let x = pageX - $mapContainer.offset().left;
    // Calculate our transform
    let transform = Math.max(0, Math.min(x, $mapContainer.outerWidth()));
    const clip = $mapContainer.width() - transform;
    $leftMap.css("width", $mapContainer.width());
    $leftMapContainer.css("right", clip.toString() + "px");
    $scroller.css("left", transform - 25 + "px");
  }
};

const stopEvents = event => {
  event.preventDefault();
  event.stopPropagation();
  event.cancelBubble = true;
  event.returnValue = false;
};

const startSliding = event => {
  stopEvents(event);
  scrolling = true;
  $scroller.addClass("scrolling");
};

const stopSliding = () => {
  scrolling = false;
  $scroller.removeClass("scrolling");
};

const setUpSliderEvents = () => {
  $scroller.on("mousedown", startSliding);
  $body.on("mouseup", stopSliding);
  $body.on("mouseleave", stopSliding);
  $body.on("mousemove", event => {
    stopEvents(event);
    respondToSlider(event.pageX);
    return false;
  });
  $scroller.on("touchstart", startSliding);
  $body.on("touchend", stopSliding);
  $body.on("touchcancel", stopSliding);
  $mapContainer.on("touchmove", event => {
    stopEvents(event);
    respondToSlider(event.touches[0].pageX);
    return false;
  });
};

const resetNeighborhoods = () => {
  neighborhoodFilter.setFilters({ notEq: " " });
  $buttonShowAll.addClass("hidden");
  $areaLabel.text("Seattle");
};

const getDataByName = (data, name) =>
  data.categories.find(el => el.name === name);

const getPercentageFromData = (data, categoryName, total) => {
  const categoryData = getDataByName(data, categoryName);
  if (categoryData) {
    const percentage = (categoryData.value / total) * 100;
    return Number.parseFloat(percentage).toFixed(1);
  } else {
    return 0;
  }
};

const populateWidget = selector => {
  return data => {
    const $widget = $(selector);

    const setTextWithThreshold = (selector, percentage) => {
      let setText =
        percentage > 5 ? Number.parseFloat(percentage).toFixed(0) + "%" : "";
      $widget.find(selector).text(setText);
    };

    if (data.count === 0) {
      $widget.find(".sf-bar").height(0);
      setTextWithThreshold(".sf-number", 0);
      $widget.find(".mf-bar").height(0);
      setTextWithThreshold(".mf-number", 0);
      $widget.find(".other-bar").height(0);
      setTextWithThreshold(".other-number", 0);
      $widget.find(".parks-bar").height(0);
      setTextWithThreshold(".parks-number", 0);
      $widget.find(".bar__text").removeClass("hidden");
      return;
    }

    $widget.find(".bar__text").addClass("hidden");

    // Don't include unzoned land in the calculation for the total.
    const total = data.categories
      .filter(cat => cat.name !== "Unzoned Land")
      .map(cat => cat.value)
      .reduce((acc, current) => acc + current);

    const sfPercentage = getPercentageFromData(data, "Single Family", total);
    setTextWithThreshold(".sf-number", sfPercentage);
    $widget.find(".sf-bar").height(sfPercentage + "%");
    const mfPercentage = getPercentageFromData(data, "Multi-Family", total);
    setTextWithThreshold(".mf-number", mfPercentage);
    $widget.find(".mf-bar").height(mfPercentage + "%");
    const otherPercentage = getPercentageFromData(
      data,
      "All Other Zones",
      total
    );
    setTextWithThreshold(".other-number", otherPercentage);
    $widget.find(".other-bar").height(otherPercentage + "%");
    const parksPercentage = getPercentageFromData(
      data,
      "Parks and Other Public Lands",
      total
    );
    setTextWithThreshold(".parks-number", parksPercentage);
    $widget.find(".parks-bar").height(parksPercentage + "%");
  };
};

const makeDataSet = key => {
  return new carto.source.Dataset(layerData[key].dataset);
};

const makeLayer = key => {
  return new carto.layer.Layer(
    datasets[key],
    new carto.style.CartoCSS(layerData[key].style)
  );
};

const makeDataView = key => {
  return new carto.dataview.Category(datasets[key], "carto_cat", {
    operation: carto.operation.SUM,
    operationColumn: "acres"
  });
};

const setUpMap = $mapElement => {
  const map = L.map($mapElement[0], {
    zoomControl: false,
    attributionControl: false,
    scrollWheelZoom: false,
    touchExtend: false
  }).setView([47.62, -122.3], 11); // a view of the whole city
  L.tileLayer(leafletLayerUrl, { maxZoom: mapMaxZoom }).addTo(map);

  return map;
};

$document.ready(() => {
  $leftMap.css("width", $mapContainer.width());
  const leftMap = setUpMap($leftMap);
  const rightMap = setUpMap($rightMap);
  L.control.zoom({ position: "bottomright" }).addTo(rightMap);

  datasets = {
    boundaries: makeDataSet("boundaries"),
    streets: makeDataSet("streets"),
    "1917": makeDataSet("1917"),
    "1923": makeDataSet("1923"),
    "1960": makeDataSet("1960"),
    "2017": makeDataSet("2017"),
    "2020": makeDataSet("2020")
  };

  layers = {
    boundaries: makeLayer("boundaries"),
    streets: makeLayer("streets"),
    "1917": makeLayer("1917"),
    "1923": makeLayer("1923"),
    "1960": makeLayer("1960"),
    "2017": makeLayer("2017"),
    "2020": makeLayer("2020")
  };

  widgets = {
    "1917": {
      dataview: makeDataView("1917"),
      selector: ".widget-1917"
    },
    "1923": {
      dataview: makeDataView("1923"),
      selector: ".widget-1923"
    },
    "1960": {
      dataview: makeDataView("1960"),
      selector: ".widget-1960"
    },
    "2017": {
      dataview: makeDataView("2017"),
      selector: ".widget-2017"
    },
    "2020": {
      dataview: makeDataView("2020"),
      selector: ".widget-2020"
    }
  };

  currentLeftLayer = layers[$leftButtonGroup.val()];

  // Start up the maps
  rightClient.addLayer(layers["streets"]);
  rightClient.addLayer(layers["2020"]);
  rightClient.getLeafletLayer().addTo(rightMap);
  rightClient.addLayer(layers["boundaries"]);

  leftClient.addLayer(currentLeftLayer);
  leftClient.getLeafletLayer().addTo(leftMap);
  leftClient.addLayer(layers["boundaries"]);
  leftClient.addLayer(layers["streets"]);

  rightMap.sync(leftMap);
  leftMap.sync(rightMap);

  // Filter the data by what's shown in the map
  const bboxFilter = new carto.filter.BoundingBoxLeaflet(rightMap);

  // Get neighborhood-specific bar charts
  neighborhoodFilter = new carto.filter.Category("name", { notEq: " " });
  datasets["1917"].addFilter(neighborhoodFilter);
  datasets["1923"].addFilter(neighborhoodFilter);
  datasets["1960"].addFilter(neighborhoodFilter);
  datasets["2017"].addFilter(neighborhoodFilter);
  datasets["2020"].addFilter(neighborhoodFilter);


  layers["boundaries"].setFeatureClickColumns(["name"]);
  layers["boundaries"].on("featureClicked", featureEvent => {
    const name = featureEvent.data.name;
    $areaLabel.text(name);
    neighborhoodFilter.setFilters({ eq: name });
    $buttonShowAll.removeClass("hidden");
  });

  // Start up the widgets
  Object.keys(widgets).forEach(w => {
    const dataview = widgets[w].dataview;
    dataview.addFilter(bboxFilter);
    rightClient.addDataview(dataview);
    const selector = widgets[w].selector;
    dataview.on("dataChanged", populateWidget(selector));
  });

  // Make the selector buttons listen to selections
  $leftButtonGroup.on("change", swapLayer(currentLeftLayer, leftClient));

  // Make the 'show all neighborhoods' button work
  $buttonShowAll.on("click", resetNeighborhoods);

  setUpSliderEvents();
});
